class OiRentObjectOverview {
    private overviewElement: HTMLElement;
    private teasers: NodeListOf<HTMLElement>;
    private noResultsMessage: HTMLElement;


    // Filter Inputs
    private locationFilter: HTMLInputElement;
    private typeFilter: HTMLSelectElement;
    private roomsFromFilter: HTMLInputElement;
    private roomsToFilter: HTMLInputElement;
    private priceFromFilter: HTMLInputElement;
    private priceToFilter: HTMLInputElement;
    private resetFiltersBtn: HTMLButtonElement;


    constructor(overviewElement: HTMLElement) {
        this.overviewElement = overviewElement;

        this.teasers = this.overviewElement.querySelectorAll<HTMLElement>('.rent-object-teaser');
        this.noResultsMessage = this.overviewElement.querySelector<HTMLElement>('#no-results-message')!;
        this.locationFilter = this.overviewElement.querySelector<HTMLInputElement>('#filter-location')!;
        this.typeFilter = this.overviewElement.querySelector<HTMLSelectElement>('#filter-type')!;
        this.roomsFromFilter = this.overviewElement.querySelector<HTMLInputElement>('#filter-rooms-from')!;
        this.roomsToFilter = this.overviewElement.querySelector<HTMLInputElement>('#filter-rooms-to')!;
        this.priceFromFilter = this.overviewElement.querySelector<HTMLInputElement>('#filter-price-from')!;
        this.priceToFilter = this.overviewElement.querySelector<HTMLInputElement>('#filter-price-to')!;
        this.resetFiltersBtn = this.overviewElement.querySelector<HTMLButtonElement>('#reset-filters-btn')!;


        this.initEventListeners();
    }

    private initEventListeners(): void {
        const filters = [
            this.locationFilter,
            this.typeFilter,
            this.roomsFromFilter,
            this.roomsToFilter,
            this.priceFromFilter,
            this.priceToFilter
        ];

        filters.forEach(filter => {
            if(filter) {
                filter.addEventListener('input', () => this.applyFilters());
                filter.addEventListener('change', () => this.applyFilters());
            }
        });

        if (this.resetFiltersBtn) {
            this.resetFiltersBtn.addEventListener('click', () => this.resetFilters());
        }

        window.addEventListener('pageshow', () => {
            this.applyFilters();
        });

    }

    private applyFilters(): void {
        const locationTerm = this.locationFilter.value.toLowerCase().trim();
        const selectedType = this.typeFilter.value;

        const minRooms = parseFloat((this.roomsFromFilter.value || '0').replace(',', '.')) || 0;
        const maxRooms = parseFloat((this.roomsToFilter.value || 'Infinity').replace(',', '.')) || Infinity;
        const minPrice = parseFloat((this.priceFromFilter.value || '0').replace(',', '.')) || 0;
        const maxPrice = parseFloat((this.priceToFilter.value || 'Infinity').replace(',', '.')) || Infinity;

        let visibleCount = 0;

        this.teasers.forEach(teaser => {

            const roomsString = teaser.dataset.rooms || '0';
            const priceString = teaser.dataset.price || '0';
            const teaserData = {
                rooms: parseFloat(roomsString.replace(',', '.')),
                price: parseFloat(priceString.replace(',', '.')),
                type: teaser.dataset.type || '',
                city: (teaser.dataset.city || '').toLowerCase(),
                zip: teaser.dataset.zip || ''
            };

            const locationMatch = locationTerm === '' || teaserData.city.includes(locationTerm) || teaserData.zip.includes(locationTerm);
            const typeMatch = selectedType === '' || teaserData.type === selectedType;
            const roomsMatch = teaserData.rooms >= minRooms && teaserData.rooms <= maxRooms;
            const priceMatch = teaserData.price >= minPrice && teaserData.price <= maxPrice;

            if (locationMatch && typeMatch && roomsMatch && priceMatch) {
                teaser.classList.remove('hidden');
                visibleCount++;
            } else {
                teaser.classList.add('hidden');
            }
        });
        
        if (visibleCount === 0) {
            this.noResultsMessage.classList.remove('hidden');
        } else {
            this.noResultsMessage.classList.add('hidden');
        }

    }

    private resetFilters(): void {
        this.locationFilter.value = '';
        this.typeFilter.value = '';
        this.roomsFromFilter.value = '';
        this.roomsToFilter.value = '';
        this.priceFromFilter.value = '';
        this.priceToFilter.value = '';

        this.applyFilters();
    }

}

export default OiRentObjectOverview;